export default {
  APP_ID: process.env.VUE_APP_WX_APP_ID,
  SHARE_APP_ID: process.env.VUE_APP_SHARE_APP_ID,
  TOKEN_NAME: 'user_token',
  REDIRECT_URL: 'http://app.mmcb.top/',
  SENTRY_URL: 'https://44b2c6b625b344b9959499d723d0f743@sentry.cmcm.us/7',
  AUTH_TYPE: 'snsapi_base', // 微信弹框授权方式: snsapi_base - 静默授权, snsapi_userinfo - 弹框授权
  POLLING_TIMES: 5, // 轮询(订单支付状态)次数
  POLLING_INTERVAL: 2000 // 轮询(订单支付状态)间隔
}
